export default __webpack_public_path__ + "static/media/Experience_Rapid_Theme.4374fa6f.png";